import { render, staticRenderFns } from "./PageCover.vue?vue&type=template&id=719cf3ce&scoped=true"
import script from "./PageCover.vue?vue&type=script&lang=js"
export * from "./PageCover.vue?vue&type=script&lang=js"
import style0 from "./PageCover.vue?vue&type=style&index=0&id=719cf3ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719cf3ce",
  null
  
)

export default component.exports